import { useTranslation } from 'react-i18next';
import { CustomTooltip } from '../../../../components/atoms';
import { formatCurrency } from '../../../../utils/formatCurrency';

const calcTot = (data: any[]) => {
  if (!Array.isArray(data)) {
    return 0;
  }

  return data.reduce((acc, cV) => {
    const value = Number(cV?.value);
    return Number.isFinite(value) ? acc + value : acc;
  }, 0);
};

const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const CardInfo: React.FC<any> = ({ data, primaryColor, jurisdictionLabel }: any) => {
  const { t } = useTranslation();
  const safeData = Array.isArray(data) ? data : [];
  const packageJurisdiction = jurisdictionLabel || safeData[0]?.jurisdiction_description || '';

  return (
    <>
      <div className="flex w-full flex-col items-center justify-center rounded-lg bg-white shadow-lg">
        <h4 style={{ color: primaryColor }} className="w-full border-b-2 py-4 text-center text-base font-bold">
          {`${t('PackageTitle')} ${packageJurisdiction}`.trim()}
        </h4>

        <div className="w-full ">
          {safeData.map((addon: any, index: number) => (
              <div key={addon.id ?? `${addon.description}-${index}`} className="flex justify-between gap-0 border-b-2 px-6 py-2">
                  <div>
                    <span className="text-sm text-[#585858]">{toTitleCase(addon.description || '')}</span>
                  </div>
                  <span style={{ color: primaryColor }} className="l-2 flex text-sm font-bold">
                    {addon?.value !== null && addon?.value !== undefined ? formatCurrency(Number(addon.value) || 0) : ''}
                    <CustomTooltip content={addon.tooltip} />
                  </span>
                </div>
            ))}
        </div>
        <div className="flex w-full flex-row items-end justify-end gap-3 border-t-2 px-6 py-4">
          <span style={{ color: primaryColor }} className="font-bold">
            Total: {formatCurrency(calcTot(safeData))}
          </span>
        </div>
      </div>
    </>
  );
};
